module.exports = __webpack_public_path__ + "img/filter.ed686767.svg";